/**
 * Calculates the max and min font size limits of an element scaled proportionally from its size.
 * Assumes the element is scaled proportionally (width and height never change independently).
 */
export const calculateFontSizesFromDimensions = (
    previewWidth: number,
    epsWidth: number,
    epsMinSizePx: number,
    epsMaxSizePx: number
): { min: number; max: number } => ({
    min: (previewWidth * epsMinSizePx) / epsWidth,
    max: (previewWidth * epsMaxSizePx) / epsWidth
});

/**
 * Scales the initial position and font size of an editable text proportionally to its size
 */
export const calculateInitTextValues = (
    previewWidth: number,
    epsWidth: number,
    epsInitCenterX: number,
    epsInitCenterY: number,
    epsInitFontSize: number
): { initCenterX: number; initCenterY: number; initFontSize: number } => ({
    initCenterX: (previewWidth * epsInitCenterX) / epsWidth,
    initCenterY: (previewWidth * epsInitCenterY) / epsWidth,
    initFontSize: (previewWidth * epsInitFontSize) / epsWidth
});
